import { Container, Divider } from '@chakra-ui/react';
import HeaderBar from 'components/ui/HeaderBar';
import { FormProvider, useForm } from 'react-hook-form';
import Filters from '../components/Filters';
import MetricsChart from '../components/MetricsChart';
import MetricStatCards from '../components/MetricStatCards';

export default function PageAnalytics() {
  const methods = useForm({
    mode: 'all',
    defaultValues: {
      dateRange: 'last7day',
      contentGroups: [],
      lists: [],
    },
  });

  return (
    <FormProvider {...methods}>
      <HeaderBar
        title="Analytics"
        description="Visão geral e estatística dos disparos"
      />

      <Divider />

      <Container flexDirection="column">
        <Filters />

        <MetricStatCards />

        <MetricsChart />
      </Container>
    </FormProvider>
  );
}
